import React from "react";

const Button = ({
  children,
  ariaLabel = "",
  variant = "primary",
  className,
  style,
  size = "default",
  onClick,
  disabled = false,
  type = "button",
}) => {
  const btnSize = {
    default: "",
    lg: "arr-btn-lg",
    sm: "arr-btn-sm",
  };
  const btnVariant = {
    primary: "arr-btn-primary",
    outline: "arr-btn-outline",
    ghost: "arr-btn-ghost",
    danger: "arr-btn-danger",
    success: "arr-btn-success",
  };
  return (
    <button
      type={type}
      onClick={onClick}
      style={style}
      aria-label={ariaLabel}
      disabled={disabled}
      className={`${btnSize[size] + " " + btnVariant[variant]} ${className} arr-btn`}
    >
      {children}
    </button>
  );
};

export default Button;
